<template>
    <tbody>
        <tr>
            <td v-if="!this.retired || this.lossOfEarnings">
                <date-input v-model="innerPeriod.startOfPeriod"
                            v-field-control.required="{type:'date', name:'startOfPeriod' + index}"
                            required
                            :emit="true"
                            @input="updateNextPeriod()"
                ></date-input>
            </td>
            <td v-if="!this.retired || this.lossOfEarnings">
                <date-input v-model="innerPeriod.endOfPeriod"
                            v-field-control.required="{type:'date', name:'endOfPeriod' + index}"
                            required
                            :emit="true"
                            @input="updateNextPeriod()"
                ></date-input>
            </td>
            <td v-if="!retired">
                <select v-model="innerPeriod.employmentType" @change="updatePeriod()">
                    <option value="employed">Employed</option>
                    <option value="self_employed">Self-employed</option>
                    <option value="part_employed">Part-employed</option>
                    <option value="not_employed">Not employed</option>
                </select>
            </td>
            <td v-if="!retired">
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" min="0" v-model.number="innerPeriod.employmentIncome"
                           v-field-control.required="{type:'number', name:'employmentIncome' + index}"
                           v-two-dp
                           @input="updatePeriod()">
                </div>
            </td>
            <td v-if="!retired">
                <select v-model="innerPeriod.employmentNetGross" @change="updatePeriod()">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </td>
            <td v-if="retired && type === 'past'">
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" min="0" v-model.number="innerPeriod.employmentIncome"
                           v-field-control.required="{type:'number', name:'employmentIncome' + index}"
                           v-two-dp
                           @input="updatePeriod()">
                </div>
            </td>
            <td v-else>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" min="0" v-model.number="innerPeriod.pensionIncome"
                           v-field-control.required="{type:'number', name:'pensionIncome' + index}"
                           @input="updatePeriod()">
                </div>
            </td>
            <td v-if="retired && type === 'past'">
                <select v-model="innerPeriod.employmentNetGross" @change="updatePeriod()">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </td>
            <td v-else>
                <select v-model="innerPeriod.pensionNetGross" @change="updatePeriod()">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </td>
            <td v-if="!retired ">
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" v-model.number="innerPeriod.totalGrossIncome" v-two-dp disabled>
                </div>
            </td>
            <td>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" v-model.number="innerPeriod.totalNetIncome" v-two-dp disabled>
                </div>
            </td>
            <td v-if="this.index === 0">
                <div :class="{ 'a-loader--total' : loading }"></div>
                <button v-if="!loading" class="a-button a-button--delete a-button--delete-disabled a-button--small" role="button" type="button" disabled="disabled"></button>
            </td>
            <td v-else>
                <div :class="{ 'a-loader--total' : loading }"></div>
                <button v-if="!loading" class="a-button a-button--delete a-button--small" role="button" type="button" @click="deletePeriod"></button>
            </td>
        </tr>
        <tr class="a-table--error" v-if="!startOfPeriodRules || !endOfPeriodRules">
            <td :colspan="!retired ? 10 : 6">
                <control-error :show="!startOfPeriodRules">
                    The income period start date must be a valid date, can not be before the claimant's onset of symptoms and
                    cannot be after the claimants's <span v-if="this.type === 'past'">assumed settlement</span> <span v-else>'but for' date of death</span>
                </control-error>
                <control-error :show="!endOfPeriodRules">
                    The income period end date must be a valid date, can not be before the claimant's onset symptoms of and
                    cannot be after the claimants's <span v-if="this.type === 'past'">assumed settlement</span> <span v-else>'but for' date of death</span>
                </control-error>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import moment from 'moment';
    import {mapActions, mapGetters} from 'vuex';
    import DateInput from 'components/form/control/DateInput.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import IncomePeriodMix from 'pages/lost-years-claims/steps/income/income-period.mixin';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import {validDate} from 'components/form/validator/validations';

    export default {
        name: 'income-period',
        mounted() {
          this.updatePeriod();
        },
        components: {
            DateInput,
            Control,
            ControlError,
        }, 
        props: {
            startDisabled: {
                type: Boolean,
                required: false
            },
            retired: {
                type: Boolean,
                required: true
            },
            lossOfEarnings: {
                type: Boolean,
                required: true
            },
            index: {
                type: Number,
                default: 0
            },
            maxIndex: {
                type: Number,
                default: 0
            },
            type: {
                type: String,
                required: true
            }
        },
        mixins: [
            currencyFormat,
            IncomePeriodMix,
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('lost/claimant', [
                'claimant',
                'getIncomePeriod',
                'getClaimantInfoValue',
                'getIncomeStatus'
            ]),
            startOfPeriodRules() {
                if (!validDate(this.innerPeriod.startOfPeriod) || this.innerPeriod.startOfPeriod === '' || this.innerPeriod.startOfPeriod === null) {
                    return false;
                }
                if (moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.claimant.onsetOfSymptoms, 'DD/MM/YYYY'))) {
                    return false;
                }
                if (moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.endOfPeriod, 'DD/MM/YYYY'))) {
                    return false;
                }
                return true;
            },
            endOfPeriodRules() {
                if (!validDate(this.innerPeriod.endOfPeriod) || this.innerPeriod.endOfPeriod === '' || this.innerPeriod.endOfPeriod === null) {
                    return false;
                }
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.claimant.onsetOfSymptoms, 'DD/MM/YYYY'))) {
                    return false;
                }
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.endOfPeriod, 'DD/MM/YYYY'))) {
                    return false;
                }
                return true;
            },
            endOfPeriod() {
                let endOfPeriod = this.getClaimantInfoValue('assumedSettlement');

                if (this.type === "future") {
                    endOfPeriod = this.claimant.lifeExpectancy.dateOfDeath;
                }

                return endOfPeriod;
            },
            loading: {
                get() {
                    return this.getIncomeStatus
                }
            },
        },
        methods: {
            ...mapActions('lost/claimant', [
                'updateIncomePeriodValue',
                'deleteIncomePeriod',
                'addIncomePeriod'
            ]),
            updatePeriod() {
                this.$emit('update', {index: this.index, period: this.innerPeriod});
            },
            deletePeriod(){
                let maxIndex = this.maxIndex - 1;
                let prevIndex = this.index - 1;
                let nextIndex = this.index + 1;
                let nextPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: prevIndex }).endOfPeriod;
                let nextDay = moment(nextPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                (this.index === maxIndex) ? this.updateIncomePeriodValue({ type: this.type, index: prevIndex, key: 'endOfPeriod', value: this.endOfPeriod})
                    : this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay});

                this.deleteIncomePeriod({index: this.index, type: this.type});
            },
            updateNextPeriod() {
                let maxIndex = this.maxIndex - 1;
                this.updatePeriod();

                if (this.index < maxIndex) {
                    let nextIndex = this.index + 1;
                    let nextDay = moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                    this.updateIncomePeriodValue({ type: this.type, index: nextIndex, key: 'startOfPeriod', value: nextDay});

                    for (let i = nextIndex, len = maxIndex; i <= len; i++) {
                        let prevPeriodEndOfPeriod = '';
                        let periodEndOfPeriod = '';
                        let periodStartOfPeriod = '';

                        prevPeriodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i - 1}).endOfPeriod;
                        periodEndOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).endOfPeriod;
                        periodStartOfPeriod = this.getIncomePeriod({ type: this.type, index: i }).startOfPeriod;

                        if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                            periodStartOfPeriod = moment(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                            this.updateIncomePeriodValue({ type: this.type, index: i, key: 'startOfPeriod', value: periodStartOfPeriod})
                        }

                        if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                            this.updateIncomePeriodValue({ type: this.type, index: i, key: 'endOfPeriod', value: periodStartOfPeriod})
                        }
                    }
                }

                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.endOfPeriod, 'DD/MM/YYYY'))
                    && moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.innerPeriod.startOfPeriod, 'DD/MM/YYYY'))
                    && this.index === maxIndex) {
                    this.addIncomePeriod(this.type);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// IncomePeriod.vue?18e529e2